$(() => {
  const $basket = $('.cart-quantity');
  const basketItems = parseInt($basket.innerText);
  if (basketItems > 99) {
    $('.quantity').css('margin-right', '10px');
  }
});
